import { Library } from 'lucide-react'

import { DOCUMENT_LIBRARY_COPY } from '#app/routes/mocra+/_form+/components/document-libraries/constants.ts'
import {
	documentLibraryCardTitle,
	formatDocumentLibrarySummary,
	type DocumentLibraryDraft,
} from '#app/routes/mocra+/_form+/components/document-libraries/types.ts'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'

type Props = {
	readonly library: DocumentLibraryDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function DocumentLibraryCard({
	library,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = documentLibraryCardTitle(library)
	const summary = formatDocumentLibrarySummary(library)
	const hasErrors = Boolean(errors && errors.length > 0)
	const description = hasErrors ? `${summary} • Needs attention` : summary

	return (
		<EntityCard
			title={title}
			description={description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle={DOCUMENT_LIBRARY_COPY.actions.removeConfirmTitle}
			removeConfirmDescription={
				DOCUMENT_LIBRARY_COPY.actions.removeConfirmDescription
			}
			icon={
				<Library
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
			removeAriaLabel="Remove document library"
		/>
	)
}
